var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#858186}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47 40.7H1.1c-.3 0-.6-.3-.6-.6v-6.4c0-.3.3-.6.6-.6h45.8c.3 0 .6.3.6.6v6.4c.1.3-.2.6-.5.6zM1.7 39.4h44.7v-5.3H1.7v5.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.6 45.2h-9.2c-.3 0-.6-.3-.6-.6V40c0-.3.3-.6.6-.6h9.2c.3 0 .6.3.6.6v4.6c0 .3-.2.6-.6.6zm-8.5-1.1h8v-3.4h-8v3.4zM47 34.2H1.1c-.3 0-.6-.3-.6-.6V9.1c0-3.5 2.8-6.3 6.3-6.3h34.4c3.5 0 6.3 2.8 6.3 6.3v24.5c.1.3-.2.6-.5.6zM1.7 33.1h44.7v-24c0-2.8-2.3-5.1-5.1-5.1H6.9C4.1 4 1.8 6.3 1.8 9.1v24h-.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2 45.2H14.9c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h18.3c.3 0 .6.3.6.6s-.2.6-.6.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2 16.8c-.2-.1-.2-.3-.2-.6l.4-2.4-1.8-1.7c-.2-.2-.2-.4-.2-.6.1-.2.3-.4.5-.4l2.4-.4 1.1-2.2c.2-.4.9-.4 1.1 0l1.1 2.2 2.4.4c.3.1.4.2.5.4s0 .5-.2.6l-1.8 1.7.4 2.4c.1.3-.1.5-.2.6-.2.1-.3.1-.6 0l-2.2-1.1-2.2 1.1c-.2.2-.4.1-.5 0zm.2-4.6 1.1 1.1c.1.1.2.3.2.5l-.3 1.5 1.4-.7c.2-.1.4-.1.6 0l1.4.7-.3-1.5c0-.2 0-.4.2-.5l1.1-1.1-1.5-.2c-.2 0-.4-.2-.5-.3l-.7-1.4-.7 1.4c-.1.2-.3.3-.5.3l-1.5.2z",
    style: {
      fill: "#ff6868"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6 27.2c-.3 0-.6-.3-.6-.6v-5.1c0-.2.1-.3.2-.4l3.8-3.8c.9-.9 2.5-.9 3.4 0s.9 2.5 0 3.4L32.1 22c-.2.2-.6.2-.9 0s-.2-.6 0-.9l1.3-1.3c.5-.5.5-1.2 0-1.7s-1.2-.5-1.7 0l-3.6 3.6v4.8c0 .4-.3.7-.6.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.7 27.2c-.2 0-.3-.1-.4-.2-.2-.2-.2-.6 0-.9l4.9-4.9V13c0-.6-.5-1.1-1.2-1.1-.6 0-1.2.5-1.2 1.1v5.1c0 .3-.3.6-.6.6s-.6-.3-.6-.6V13c0-1.3 1.1-2.3 2.4-2.3s2.4 1 2.4 2.3v8.5c0 .2-.1.3-.2.4L32.1 27c-.1.2-.2.2-.4.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8 29.9h-7.3c-.3 0-.6-.3-.6-.6v-2.5c0-.3.3-.6.6-.6h7.3c.3 0 .6.3.6.6v2.5c0 .3-.3.6-.6.6zm-6.7-1.3h6v-1.3h-6v1.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5 27.2c-.3 0-.6-.3-.6-.6v-4.8l-3.6-3.6c-.4-.5-1.2-.5-1.7 0-.2.2-.3.5-.3.8s.1.6.3.8l1.3 1.3c.2.2.2.6 0 .9-.2.2-.6.2-.9 0l-1.3-1.3c-.9-.9-.9-2.5 0-3.4s2.5-.9 3.4 0l3.8 3.8c.1.1.2.3.2.4v5.1c0 .3-.2.6-.6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4 27.2c-.2 0-.3-.1-.4-.2l-5.1-5.1c-.1-.1-.2-.3-.2-.4V13c0-1.3 1.1-2.3 2.4-2.3 1.3 0 2.4 1 2.4 2.3v5.1c0 .3-.3.6-.6.6s-.6-.3-.6-.6V13c0-.6-.5-1.1-1.2-1.1s-1.2.5-1.2 1.1v8.2l4.9 4.9c.2.2.2.6 0 .9-.1.2-.2.2-.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.6 29.9h-7.3c-.3 0-.6-.3-.6-.6v-2.5c0-.3.3-.6.6-.6h7.3c.3 0 .6.3.6.6v2.5c0 .3-.3.6-.6.6zM16 28.6h6v-1.3h-6v1.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.280a3c885aac9b46e76b3dd62612005e.svg";
export { ForwardRef as ReactComponent };